import type { AgendaSettings } from "@bookdental/schemas";
import { Field, Toggle, settingsInputCls } from "./primitives";

type Props = {
  values: AgendaSettings;
  onChange: (partial: Partial<AgendaSettings>) => void;
};

export function BehaviorSection({ values, onChange }: Props) {
  return (
    <div className="space-y-6">
      <Field label="Ao tentar agendar em horário ocupado">
        <select
          className={settingsInputCls}
          value={values.conflictBehavior}
          onChange={(e) =>
            onChange({
              conflictBehavior: e.target.value as AgendaSettings["conflictBehavior"],
            })
          }
        >
          <option value="warn">Avisar, mas permitir</option>
          <option value="block">Bloquear o agendamento</option>
        </select>
      </Field>

      <Toggle
        label="Confirmar ao arrastar consulta"
        description="Pedir confirmação antes de remarcar por drag-drop"
        checked={values.confirmOnDrag}
        onChange={(v) => onChange({ confirmOnDrag: v })}
      />
    </div>
  );
}
